export const BASEURL = process.env.REACT_APP_BASEURL;
export const FILE_DOWNLOAD_URL = process.env.REACT_APP_FILE_DOWNLOAD_URL;
export const RZP_KEY = process.env.REACT_APP_RZP_KEY;
